/**
 * CSV para abrir en Excel o Google Sheets.
 *
 * Se entrecomilla todo, siempre: los premios llevan comas y simbolos (`+ $20
 * additional free fuel`, `Service Club®`) y los nombres los escribe cualquiera
 * en una tablet. Salta de linea con CRLF, que es lo que dice el RFC 4180 y lo
 * que Excel espera.
 */

/**
 * Marca como texto un valor que Excel interpretaria como formula.
 *
 * Hay que aplicarlo a lo que teclea el publico —nombre y correo—, porque un
 * `=1+1` o un `@SUM(...)` se ejecutarian al abrir el fichero en el ordenador
 * de quien lleva el stand. La comilla simple es como las hojas de calculo
 * marcan "esto es texto".
 *
 * A proposito NO se aplica dentro de `toCsv`: las etiquetas de premio empiezan
 * todas por `+` y saldrian con una comilla delante sin ninguna razon. Quien
 * las escribe es el operador en /config, no el publico.
 */
export function untrusted(value: string): string {
  return /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
}

function cell(value: string): string {
  return `"${value.replace(/"/g, '""')}"`;
}

export function toCsv(headers: string[], rows: string[][]): string {
  return [headers, ...rows].map((row) => row.map(cell).join(',')).join('\r\n');
}
